const dateFormatter = new Intl.DateTimeFormat('nl-NL', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

const dateTimeFormatter = new Intl.DateTimeFormat('nl-NL', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
})

const currencyFormatter = new Intl.NumberFormat('nl-NL', {
  style: 'currency',
  currency: 'EUR',
})

export function formatDate(date: string | Date): string {
  return dateFormatter.format(new Date(date))
}

export function formatDateTime(date: string | Date): string {
  return dateTimeFormatter.format(new Date(date))
}

export function formatCurrency(amount: number): string {
  return currencyFormatter.format(amount / 100)
}

export function formatCurrencyFromDecimal(amount: number): string {
  return currencyFormatter.format(amount)
}
